/* Play-on-click for the Lumora video cards section.
 *
 * Nothing loads until the visitor asks for it: <video> ships with preload="none"
 * and an iframe embed is not created at all until the button is pressed. Three
 * autoplaying clips on a product page costs bandwidth, shifts layout and makes
 * the cards fight over audio on mobile.
 *
 * Only one plays at a time -- starting one pauses any other that is running,
 * which is the behaviour people expect from a row of testimonials.
 */
(function () {
  'use strict';

  var SEL = '[data-lum-vc]';

  function stopOthers(current) {
    document.querySelectorAll(SEL).forEach(function (card) {
      if (card === current) return;
      var v = card.querySelector('video');
      if (v && !v.paused) {
        v.pause();
        card.classList.remove('is-playing');
        var b = card.querySelector('.lum-vc__play');
        if (b) b.hidden = false;
      }
      // An iframe cannot be paused without its JS API, so it is torn down.
      var frame = card.querySelector('iframe');
      if (frame) {
        var holder = card.querySelector('.lum-vc__embed');
        if (holder) holder.innerHTML = '';
        card.classList.remove('is-playing');
        var b2 = card.querySelector('.lum-vc__play');
        if (b2) b2.hidden = false;
      }
    });
  }

  function embedSrc(holder) {
    var type = (holder.getAttribute('data-lum-vc-type') || '').toLowerCase();
    var id = holder.getAttribute('data-lum-vc-id') || '';
    if (!id) return null;
    if (type === 'youtube') {
      return 'https://www.youtube.com/embed/' + encodeURIComponent(id) +
             '?autoplay=1&rel=0&playsinline=1';
    }
    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + encodeURIComponent(id) +
             '?autoplay=1&playsinline=1';
    }
    return null;
  }

  function play(card) {
    var button = card.querySelector('.lum-vc__play');
    var video = card.querySelector('video');
    var holder = card.querySelector('.lum-vc__embed');

    stopOthers(card);

    if (video) {
      // Controls are off until play so the card matches the reference still.
      video.controls = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // Autoplay policies can refuse a programmatic play with sound.
          // Leaving controls on means the native button still works.
          card.classList.remove('is-playing');
          if (button) button.hidden = false;
        });
      }
      card.classList.add('is-playing');
      if (button) button.hidden = true;
      return;
    }

    if (holder) {
      var src = embedSrc(holder);
      if (!src) return;
      var frame = document.createElement('iframe');
      frame.src = src;
      frame.loading = 'lazy';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.setAttribute('title', 'Video');
      holder.innerHTML = '';
      holder.appendChild(frame);
      card.classList.add('is-playing');
      if (button) button.hidden = true;
    }
  }

  function wire(card) {
    if (card.dataset.lumVcReady === '1') return;
    card.dataset.lumVcReady = '1';

    var button = card.querySelector('.lum-vc__play');
    if (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        play(card);
      });
    }

    var video = card.querySelector('video');
    if (video) {
      // If the visitor pauses with the native controls, bring the poster and
      // the big button back rather than leaving a frozen frame.
      video.addEventListener('ended', function () {
        video.controls = false;
        video.currentTime = 0;
        card.classList.remove('is-playing');
        if (button) button.hidden = false;
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll(SEL).forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify re-renders a section on every change in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
